const numberFormatter = new Intl.NumberFormat('en-US')

export const defaultFormatter = (value) => {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'number' && !Number.isFinite(value)) return '—'
  return String(value)
}

export const formatNumber = (value) => {
  const numeric = Number(value)
  if (Number.isNaN(numeric)) return value
  return numberFormatter.format(numeric)
}

export const formatCompactNumber = (value) => {
  if (value === null || value === undefined || value === '') return '—'
  const numeric = Number(value)
  if (Number.isNaN(numeric)) return '—'
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(numeric)
}

export function formatPercent(value, decimals) {
  try {
    const n = Number(value)
    if (!Number.isFinite(n)) return '—'

    let d = Number(decimals)
    if (!Number.isFinite(d)) d = 0
    d = Math.trunc(d)
    if (d < 0) d = 0
    if (d > 20) d = 20

    const v = n > 1 ? n / 100 : n

    return new Intl.NumberFormat(undefined, {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: d,
    }).format(v)
  } catch (error) {
    return '—'
  }
}

export const formatCurrency = (value, currency = 'USD', fractionDigits = 0) => {
  const numeric = Number(value)
  if (Number.isNaN(numeric)) return value
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: fractionDigits,
  }).format(numeric)
}
